import React from 'react';
import { Alert } from 'react-bootstrap';

function ConfigurationHome() {
  return (
    <div>
      <h2>Configuration Management</h2>
      <Alert variant="info">
        Welcome to the configuration management section. Please select an option from the left navigation menu to get started.
      </Alert>
    </div>
  );
}

export default ConfigurationHome;
